import type { FunctionComponent } from 'react';

import type { SvgProps } from './types';

export const AbbUpload: FunctionComponent<SvgProps> = ({ fill = '#1f1f1f', size = 14, ...props }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill={fill} width={size} height={size} {...props}>
      <g id='Box'>
        <rect fill='none' width={size} height={size} />
      </g>
      <g id='Final_icons_-_Common' data-name='Final icons - Common'>
        <polygon points='11 6 11 18 13 18 13 6 16 9 17.5 7.5 12 2 6.5 7.5 8 9 11 6' />
        <path d='M21,16v4H3V16H1v4a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V16Z' />
      </g>
    </svg>
  );
};
